// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ha0h","footer":"ModalCreateQualiphyProcedure_footer__3mNwD","additionData":"ModalCreateQualiphyProcedure_additionData__2i3ke"};